@if (showModalChrome) {

  <div class="modal-header s3-file-upload-modal-header">
    <h3 class="modal-title s3-file-upload-modal-title">
      <span>File Upload</span>
    </h3>
    <div class="header-actions">
      <i
        class="fa fa-times s3-file-upload-modal-close"
        (click)="closeModal()"
        role="button"
        tabindex="0"
        (keydown.enter)="closeModal()"
        (keydown.space)="$event.preventDefault(); closeModal()"
        aria-label="Close"
      ></i>
    </div>
  </div>
  <div class="modal-body s3-file-upload-modal-body" [ngClass]="currentTheme">
    <ng-container *ngTemplateOutlet="s3Body"></ng-container>
  </div>

}

@if (!showModalChrome) {

  <div class="s3-upload-inline">
    <ng-container *ngTemplateOutlet="s3Body"></ng-container>
  </div>

}

<ng-template #s3Body>
  @if (showModalChrome && !s3FileUploadInput.hidePath) {
<div
    class="legacy-path ap-px-spacing-6"
   
  >
    <span>{{ rootFolder }}</span>
    @for (label of breadCrumbLinks; track $index) {

      <span class="slash"> / </span><span>{{ label }}</span>
    
}
    <span class="slash"> / </span>

    @if (isNewFile && s3FileUploadInput.canEditPath) {
<div
     
      class="s3-folder-input-group d-inline-flex align-items-center"
    >
      <ap-field
        [title]="'Enter new folder name'"
        [hideTitleOnInput]="true"
        [styleClass]="'s3-folder-field ap-form-field-my-wrapper'"
      >
        <input
          appkit-field
          aria-label="Enter new folder name"
          id="s3FolderNameInput"
          name="s3FolderNameInput"
          [ngModel]="newFolder"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="newFolder = $event"
          placeholder="Enter new folder name"
          (keydown.enter)="onAddFolderClick()"
        />
      </ap-field>
      <ap-button
        class="s3-add-folder-button"
        [label]="'Add'"
        [btnType]="'primary'"
        [compact]="true"
        [ariaLabel]="'Add folder'"
        (onClick)="onAddFolderClick()"
      ></ap-button>
    </div>
}
  </div>
}

  @if (!showModalChrome && !s3FileUploadInput.hidePath) {
<div
    class="path-input ap-px-spacing-6 ap-mb-spacing-3 gtw-web-components d-flex flex-wrap align-items-center"
   
  >
    <ap-breadcrumb
      [styleClass]="'gtw-s3-breadcrumb ap-px-spacing-2'"
      [class.max-width-60p]="isNewFile"
    >
      <ap-breadcrumb-item>
        @if (breadCrumbLinks.length === 0) {
<span aria-current="page" tabindex="-1">{{ rootFolder }}</span>
} @else {
<span tabindex="0">{{ rootFolder }}</span>
}
      </ap-breadcrumb-item>
      @for (label of breadCrumbLinks; track $index; let last = $last) {
<ap-breadcrumb-item>
        @if (last) {
<span aria-current="page" tabindex="-1">{{ label }}</span>
} @else {
<span tabindex="0">{{ label }}</span>
}
      </ap-breadcrumb-item>
}
    </ap-breadcrumb>

    @if (isNewFile && s3FileUploadInput.canEditPath) {
<div
     
      class="s3-folder-input-group d-flex align-items-center"
    >
      <ap-field
        [title]="'Enter new folder name'"
        [hideTitleOnInput]="true"
        [styleClass]="'s3-folder-field ap-form-field-my-wrapper'"
      >
        <input
          appkit-field
          aria-label="Enter new folder name"
          id="s3FolderNameInput"
          name="s3FolderNameInput"
          [ngModel]="newFolder"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="newFolder = $event"
          placeholder="Enter new folder name"
          (keydown.enter)="onAddFolderClick()"
        />
      </ap-field>
      <ap-button
        class="s3-add-folder-button"
        [label]="'Add'"
        [btnType]="'primary'"
        [compact]="true"
        [ariaLabel]="'Add folder'"
        (onClick)="onAddFolderClick()"
      ></ap-button>
    </div>
}
  </div>
}

  @if (!s3FileUploadInput.hidePath) {
<div
   
    class="s3-path-separator a-border-bt ap-my-spacing-3"
    role="separator"
    aria-hidden="true"
  ></div>
}

  @if (isNewFile && !s3FileUploadInput.onlyCore && !s3FileUploadInput.hidePath) {
<div
    class="s3-client-specific-row d-flex align-items-center justify-content-center ap-mb-spacing-3"
   
  >
    <ap-checkbox
      [styleClass]="'s3-client-specific-checkbox'"
      [name]="'s3ClientSpecificFile'"
      [inputId]="'s3ClientSpecificFile'"
      [ariaLabel]="'Client specific file'"
      [labelPosition]="'right'"
      [ngModel]="isClientSpecificFile"
      [ngModelOptions]="{ standalone: true }"
      (onChange)="onClientSpecificFlagChanged($event)"
    >
    </ap-checkbox>
    <label class="s3-client-specific-label" for="s3ClientSpecificFile">
      Client specific file
    </label>
  </div>
}

  <div
    class="upload-container"
    [class.upload-container--legacy]="showModalChrome"
    [class.upload-container--efile-embedded]="isEfileEmbeddedUpload"
    [class.upload-container--disabled]="!!disabledText"
    [attr.data-disabled-text]="disabledText"
  >
    @if (!isNewFile) {
<ap-button
     
      class="s3-download-trigger"
      [btnType]="'text'"
      [compact]="true"
      [attr.title]="'Download file from S3'"
      [attr.aria-label]="'Download file from S3'"
      (onClick)="downloadFileFromS3()"
    >
      <span class="Appkit4-icon icon-download-light-outline" aria-hidden="true"></span>
      <span class="s3-download-trigger__label">Download</span>
    </ap-button>
}

    <div class="s3-upload-form">
      <div class="s3-upload-form__title">{{ title }}</div>
      <div class="s3-upload-form__instruction">{{ description }}</div>

      <label
        class="s3-upload-form__dropzone"
        [class.s3-upload-form__dropzone--has-file]="!!selectedFile"
        [class.s3-upload-form__dropzone--disabled]="!!disabledText || uploadInProgress"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        <input
          #fileInput
          class="s3-upload-form__file-input"
          type="file"
          [disabled]="!!disabledText || uploadInProgress"
          (change)="onFileSelected($event)"
        />
        @if (!selectedFile) {
<span
         
          class="s3-upload-form__dropzone-prompt"
        >
          Drag and drop or
          <span class="s3-upload-form__browse-link">choose file</span>
        </span>
}
        @if (selectedFile) {
<span
         
          class="s3-upload-form__selected"
        >
          <span class="s3-upload-form__file-name" [title]="selectedFile.name">
            {{ selectedFile.name }}
          </span>
          <button
            type="button"
            class="s3-upload-form__clear"
            aria-label="Remove selected file"
            (click)="clearSelectedFile($event)"
            [disabled]="uploadInProgress"
          >
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </span>
}
      </label>

      <div class="s3-upload-form__actions">
        <button
          class="upload-button s3-upload-form__upload-button"
          type="button"
          [disabled]="!selectedFile || !!disabledText || uploadInProgress"
          (click)="uploadSelectedFile()"
        >
          @if (uploadInProgress) {
<span>
            <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
          </span>
}
          Upload
        </button>
      </div>
    </div>
  </div>

</ng-template>
